import { SiteAddress as SiteAddressType } from '../../../../APIDocs/apiTypes';
import { CollapsibleCard } from '../../components/CollapsibleCard';
import { Label } from '../../components/Label';

interface props {
  siteAddress: SiteAddressType;
  disableCollapse?: boolean;
}

export const SiteAddressCard = ({ siteAddress, disableCollapse }: props) => {
  return (
    <CollapsibleCard identifier="addressDetails" title="Site Address Details" disableCollapse={disableCollapse}>
      {siteAddress.AddressName && <Label title="Company Name" text={siteAddress.AddressName} />}
      {siteAddress.AddressLine1 && <Label title="Address Line 1" text={siteAddress.AddressLine1} />}
      {siteAddress.AddressLine2 && <Label title="Address Line 2" text={siteAddress.AddressLine2} />}
      {siteAddress.AddressLine3 && <Label title="Address Line 3" text={siteAddress.AddressLine3} />}
      {siteAddress.AddressLine4 && <Label title="Address Line 4" text={siteAddress.AddressLine4} />}
      {siteAddress.AddressLine5 && <Label title="Address Line 5" text={siteAddress.AddressLine5} />}
      {siteAddress.AddressLine6 && <Label title="Address Line 6" text={siteAddress.AddressLine6} />}
      {siteAddress.Town && <Label title="Town" text={siteAddress.Town} />}
      {siteAddress.County && <Label title="County" text={siteAddress.County} />}
      {siteAddress.PostCode && <Label title="Post Code" text={siteAddress.PostCode} />}
    </CollapsibleCard>
  );
};
